import { Vue, Component } from 'vue-property-decorator'
import { Getter, Mutation, State } from 'vuex-class'
import { resetInjectRouter } from '@/router'

import AppDownload from '@/popup/AppDownload/AppDownload.vue'
import BindNotify from '@/popup/BindNotify/BindNotify.vue'
import MotifyPassword from '@/popup/MotifyPassword/MotifyPassword.vue'
import { hasAccountBind, hasApkDownload, hasOpenDocument } from '@/utils/global'
import { JLCK } from '@/custom/jlck'

enum E_MenuCommand {
    ModifyPassword = 'ModifyPassword',
    OpenAPIDocument = 'OpenAPIDocument',
    Logout = 'Logout',
    BindNotify = 'BindNotify',
    AppDownload = 'AppDownload',
}

@Component({
    name: 'AccoutHeader',
    components: {
        AppDownload,
        MotifyPassword,
        BindNotify,
    }
})
export class AccoutHeaderImpl extends Vue {
    @Getter
    currentUserNickName: string

    @Getter
    currentParentCompany: number

    @Mutation
    clearStates: () => void

    E_MenuCommand = E_MenuCommand

    hasAccountBind = hasAccountBind

    get HasOpenDocument() {
        if (this.currentParentCompany === JLCK.CompanyId) {
            return false
        }
        return hasOpenDocument
    }

    get HasLogout() {
        if (this.currentParentCompany === JLCK.CompanyId) {
            return false
        }
        return true
    }

    get HasApk() {
        return hasApkDownload
    }

    showMotifyPassword = false
    onMotifyPasswordClose() {
        this.showMotifyPassword = false
    }

    showBindNotify = false
    onBindNotifyClose() {
        this.showBindNotify = false
    }

    showAppDownload = false
    onAppDownloadClose() {
        this.showAppDownload = false
    }

    onCommand(command: E_MenuCommand) {
        if (command === E_MenuCommand.Logout) {
            this.clearStates()
            resetInjectRouter()
            this.$api.login.logout(this)
        } else if (command === E_MenuCommand.ModifyPassword) {
            this.showMotifyPassword = true
        } else if (command === E_MenuCommand.BindNotify) {
            this.showBindNotify = true
        } else if (command === E_MenuCommand.AppDownload) {
            this.showAppDownload = true
        } else if (command === E_MenuCommand.OpenAPIDocument) {
            window.open('http://d.jjsensor.com/_doc/', '_blank')
        }
    }

    @Getter
    needAlertSoonExpire: boolean

    @Getter
    expireTime: string

    @Mutation
    markHasAlertSoonExpire: () => void

    mounted() {
        if (this.needAlertSoonExpire) {
            const h = this.$createElement;
            this.$notify({
                title: this.$t('account.expireAlert') as string,
                message: h('span', { style: 'color: red' }, [
                    h('span', this.$t('account.yourAccountWillExpired') as string),
                    h('br'),
                    h('span', this.$t('account.expiredTime') + `${this.expireTime}`),
                ]),
                duration: 0
            });
            this.markHasAlertSoonExpire()
        }
    }
}
